import { LengthProps, useLengthStorage } from './useLengthStorage';
import { ReactElement } from 'react';

export function Length(props: LengthProps): ReactElement {

  const [length, toggle] = useLengthStorage(props);

  const id = 'Length';
  const hint = 'change the length of the password';

  return (
    <button
      className={'Frame Flame Length'} data-testid={id}
      onClick={() => toggle()}
      type={'submit'}
      title={hint}
    >{length}</button>
  );
}
